// src/pages/Login.jsx
import React, { useState, useEffect } from 'react';
import { getAuth } from 'firebase/auth';
import Header from '../components/Header';
import Footer from '../components/Footer';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { useNavigate, useLocation } from 'react-router-dom';
import { login as loginService } from '../services/auth';

const Login = () => {
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  // Estados para los campos del formulario
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  
  // Estados para mensajes de error, éxito y carga
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();
  // Si se accedió al login con datos (por ejemplo, desde Envios), se reciben en location.state
  const { sendAmount, receiveAmount, origen, destino } = location.state || {};

  // Handler para cambios en los inputs
  const handleInputChange = (setter) => (e) => {
    setter(e.target.value);
    console.log(`Input changed: ${e.target.id} = ${e.target.value}`);
  };

  // Handler para el submit del formulario de login
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    setLoading(true);

    try {
      const { user, userData } = await loginService(email, password);
      setSuccess('Inicio de sesión exitoso.');
      console.log('Usuario autenticado:', user);
      console.log('Datos de usuario:', userData); // incluye rol

      // Si se reciben datos de transacción, se pueden procesar o almacenar
      if (sendAmount !== undefined) {
        console.log("Datos de transacción recibidos:", { sendAmount, receiveAmount, origen, destino });
        // Aquí podrías guardar estos datos en un estado global o enviarlos al backend.
      }

      // Redirigir al usuario a la ruta principal (o a donde se requiera)
      navigate('/');
    } catch (err) {
      console.error(err);
      if (err.code) {
        switch (err.code) {
          case 'auth/invalid-email':
            setError("El correo ingresado no es válido.");
            break;
          case 'auth/user-not-found':
            setError("Usuario no encontrado. Verifica tu correo.");
            break;
          case 'auth/wrong-password':
            setError("Contraseña incorrecta.");
            break;
          case 'auth/network-request-failed':
            setError("Error de red. Verifica tu conexión a Internet.");
            break;
          default:
            setError(err.message || "Ocurrió un error. Por favor, inténtalo de nuevo.");
        }
      } else {
        setError("Ocurrió un error inesperado. Por favor, inténtalo de nuevo.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Header />
      <section className="hero-section" id="hero-login">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-8" data-aos="fade-right">
              <h1>Inicia Sesión en Smart Money</h1>
              <p className="mb-4">
                Ingresa tus credenciales para acceder a tu cuenta.
              </p>
            </div>
            <div className="col-lg-4" data-aos="fade-left">
              <img src="/assets/img/register.png" alt="Login" className="img-fluid" />
            </div>
          </div>
        </div>
      </section>
      <main id="main">
        <section className="section">
          <div className="container">
            {error && <div className="alert alert-danger">{error}</div>}
            {success && <div className="alert alert-success">{success}</div>}
            <form onSubmit={handleSubmit} className="php-email-form" data-aos="fade-up">
              <div className="form-group">
                <label htmlFor="email">Correo Electrónico</label>
                <input
                  type="email"
                  id="email"
                  className="form-control"
                  placeholder="Ingresa tu correo"
                  value={email || ''}
                  onChange={handleInputChange(setEmail)}
                  required
                />
              </div>
              <div className="form-group mt-3">
                <label htmlFor="password">Contraseña</label>
                <input
                  type="password"
                  id="password"
                  className="form-control"
                  placeholder="Ingresa tu contraseña"
                  value={password || ''}
                  onChange={handleInputChange(setPassword)}
                  required
                />
              </div>
              <div className="mt-4">
                <button type="submit" className="btn btn-primary" disabled={loading}>
                  {loading ? "Procesando..." : "Iniciar Sesión"}
                </button>
              </div>
              <p className="mt-3">
                <a href="/recuperar-contrasena">¿Olvidaste tu contraseña?</a>
              </p>
              <p className="mt-3">
                ¿No tienes una cuenta? <a href="/registro">Regístrate aquí</a>
                </p>
            </form>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
};

export default Login;
